'use client';

import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useStyles } from './style';

/**
 * @name UtteranceDescription
 * @param {object} props - Strapi Data
 * @returns {JSX.Element} - Renders descriptions of utterance tiles
 */
const UtteranceDescription = props => {
  const theme = useTheme();
  const style = useStyles(theme);

  return (
    <Stack direction='column' alignItems='flex-start' sx={style.utteranceTexts}>
      <Typography variant='h5'>{props.title}</Typography>
      <Typography variant='body1'>{props.description}</Typography>
    </Stack>
  );
};

UtteranceDescription.displayName = 'UtteranceDescription';
export default UtteranceDescription;
